import { createContext } from 'react';
export type BookingEngineContextType = Readonly<{
  currentStep: BookingPageData;
}>;
export const BookingEngineContext = createContext<BookingEngineContextType>(undefined);
